import { render, staticRenderFns } from "./AlgoliaSort.vue?vue&type=template&id=5d5d0426&scoped=true&"
import script from "./AlgoliaSort.vue?vue&type=script&lang=js&"
export * from "./AlgoliaSort.vue?vue&type=script&lang=js&"
import style0 from "./AlgoliaSort.vue?vue&type=style&index=0&id=5d5d0426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5d0426",
  null
  
)

export default component.exports